import { Badge, Button, Dropdown, Flex, Space, Switch } from "antd";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { useTranslation } from "react-i18next";
import TableAntd from "components/elements/Table";
import { DeleteOutlined, EditOutlined, MoreOutlined, RedoOutlined } from "@ant-design/icons";
import EmployeeWelfareModal from "./EmployeeWelfareModal";
import EmployeeEditWelfare from "./EmployeeEditWelfare";
import { useState } from "react";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import { ReactComponent as EyeIcon } from "../../../assets/icon/eyeIcon.svg";
import { ReactComponent as EyeHideIcon } from "../../../assets/icon/eyeClose.svg";

const EmployeeWelfareComponent = ({
    showModal,
    isModalOpen = false,
    pagination = {},
    employeeWelfareList = [],
    setIsModalOpen = () => { },
    isVisible = false,
    setIsVisible = () => { },
    handleEdit = () => { },
    selectedRecord = {},
    updateEmployeeWelfare = () => { },
    onDelete = () => { },
    onChange = () => { },
    onStatus = () => { }
}) => {
    const { t, i18n } = useTranslation();

    const columns = [
        {
            title: <div className="text-table">{t('employee.no')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: "120px",
            render: (_, record, idx) => {
                return <Badge count={(pagination.page - 1) * pagination.size + idx + 1} style={{ backgroundColor: "#F5F6F7", color: "#313131" }} />
            },
        },
        {
            title: <div className="text-table">{t('employee.welfare.header')}</div>,
            dataIndex: "welfareName",
            key: "welfareName",
            render: (_, record) => {
                return (
                    i18n.language === "en" ? record?.welfareNameEn : record?.welfareName
                )
            }
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('welfare_list.Amout')}</div>,
            dataIndex: "amout",
            key: "amout",
            align: "center",
            render: (_, record) => {
                return (
                    record?.limit == null ? t("unlimited") : get2DecimalPointsWithCommas(record?.limit)
                )
            }
        },
        {
            title: <div className="text-table">{t('welfare_list.Number_of_rights_per_month')}</div>,
            dataIndex: "numberOfRights",
            key: "numberOfRights",
            align: "center",
            render: (_, record) => {
                return (
                    record?.numberOfRights == null ? t("unlimited") : record?.numberOfRights
                )
            }
        },
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('welfare_list.Balance')}</div>,
            dataIndex: "creditRemaining",
            key: "creditRemaining",
            align: "center",
            render: (_, record) => {
                return (
                    // isVisible ? 
                    record?.creditRemaining == null ? t("unlimited") : get2DecimalPointsWithCommas(record?.creditRemaining)
                    // : "xxx,xxx.xx"
                )
            }
        },
        {
            title: <div className="text-table">{t("welfare.label.status")}</div>,
            dataIndex: "statusFlag",
            key: "statusFlag",
            align: "center",
            width: 100,
            render: (_, record) => (
                <Switch
                    checked={record?.statusFlag === "Y"}
                    onChange={(checked) => onStatus(checked, record)}
                />
            ),
        },
        {
            title: "",
            key: "action",
            align: "center",
            width: "100px",
            render: (_, record) => {
                const menuItems = [
                    ...(record?.multipleCreditLimitFlag === "Y" ?
                        [{
                            key: "1",
                            onClick: () => handleEdit(record),
                            label: `${t("action.edit")}`,
                            icon: (
                                <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                            ),
                        }] : []),

                    ...(record?.customFlag === "Y"
                        ? [
                            {
                                key: "2",
                                onClick: () => onDelete(record),
                                label: t("action.reset"),
                                icon: <RedoOutlined style={{ fontSize: "18px", color: "gray" }} />,
                            },
                        ]
                        : []),
                ];

                if (menuItems?.length === 0) {
                    return null;
                }

                return (
                    <Space size="middle">
                        <Dropdown menu={{ items: menuItems }}>
                            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                        </Dropdown>
                    </Space>
                );
            }
        }
    ]

    return (
        <>
            <EmployeeWelfareModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                selectedRecord={selectedRecord}
                updateEmployeeWelfare={updateEmployeeWelfare}
            />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                {/* <Flex justify="end">
                    <Button
                        icon={isVisible ? <EyeHideIcon /> : <EyeIcon />}
                        onClick={() => setIsVisible(prevState => !prevState)}
                        size="large"
                    />
                </Flex> */}
                <TableAntd
                    pagination={pagination}
                    rowKey={(record) => record.id}
                    columns={columns}
                    dataSource={employeeWelfareList}
                    onChange={onChange}
                />
            </Space>
        </>
    )
}
export default EmployeeWelfareComponent;